






















































import DSelect from '~/components/atoms/DS2/DSelect'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import OptionTypePriceRange from '~/components/organisms/ServiceSearchForm/components/OptionTypePriceRange.vue'
// vuex
import { mapState } from 'vuex'
import { ConditionOptionCommon } from '~/types/services/search'

const searchConditionSelectPrice = defineComponent({
  name: 'searchConditionSelectPrice',
  inject: ['condition'],
  components: {
    DSelect,
    OptionTypePriceRange
  },
  props: {
    selectedPriceMin: {
      type: Number as PropType<number>,
      default: 0
    },
    selectedPriceMax: {
      type: Number as PropType<number>,
      default: 0
    },
    selectedUnitPriceMin: {
      type: String as PropType<string>,
      default: ''
    },
    selectedUnitPriceMax: {
      type: String as PropType<string>,
      default: ''
    },
    conditionOptionGroup: {
      type: Object as PropType<ConditionOptionCommon>,
      default: () => ({})
    },
    searchOptionMasters: {
      type: Array,
      default() {
        return []
      }
    },
    searchCondition: {
      type: Object as PropType<ConditionOptionCommon>,
      default: () => ({})
    },
    conditionOptionsCommon: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      pricesMin: [],
      pricesMax: [],
      innerCondition: {},
      categoryMaster: {}
    }
  },
  methods: {
    setCategoryMaster() {
      this.categoryMaster = {}
      if (this.innerCondition.value.masterCategoryId) {
        const parentCategory = this.innerCondition.value.categoriesList[0]
        const parentCategoryMaster = this.masterCategories.find(c => c.id === parentCategory.id)
        if (parentCategory.isCurrent) {
          this.categoryMaster = parentCategoryMaster
        } else {
          this.categoryMaster = parentCategoryMaster.subCategories.find(
            c => c.id === Number(this.innerCondition.value.masterCategoryId)
          )
        }
      }
    },
    genPrices(val = null, type = '') {
      // 現在設定されている値の取得
      let priceMin = this.innerCondition.value.priceMin
      let priceMax = this.innerCondition.value.priceMax

      // 価格一覧の初期値（minは最後、maxは最初を除く）
      let priceType = 'production'
      if (this.isCategoryLocked) {
        const parentCategoryId = this.innerCondition.value.categoriesList[0].id
        this.masterCategories.find(e => {
          if (e.id === parentCategoryId) {
            priceType = e.priceType
          }
        })
      }
      const serviceType = this.innerCondition.value.serviceType || 'text'

      if (this.pricesMaster?.[serviceType]?.[`${priceType}List`]) {
        this.pricesMin = this.$util.clone(this.pricesMaster[serviceType][`${priceType}List`])
        this.pricesMax = this.$util.clone(this.pricesMaster[serviceType][`${priceType}List`])
      } else {
        this.pricesMin = []
        this.pricesMax = []
      }

      // カテゴリ別の下限価格で最適化
      for (let i = 0; i < this.pricesMin.length; i++) {
        if (this.pricesMin[i] >= this.categoryMaster.lowestPrice) {
          this.pricesMin.splice(0, i)
          break
        }
      }
      for (let i = 0; i < this.pricesMax.length; i++) {
        if (this.pricesMax[i] >= this.categoryMaster.lowestPrice) {
          this.pricesMax.splice(0, i)
          break
        }
      }

      // 設定されている値によって価格一覧を最適化
      if (priceMax) {
        for (let i = 0; i < this.pricesMin.length; i++) {
          if (this.pricesMin[i] > priceMax) {
            this.pricesMin.splice(i, this.pricesMin.length - i)
            break
          }
        }
      }
      if (priceMin) {
        for (let i = 0; i < this.pricesMax.length; i++) {
          if (this.pricesMax[i] >= priceMin) {
            this.pricesMax.splice(0, i)
            break
          }
        }
      }

      // NOTE: 最低価格500円のみで検索できないように、上限の最低価格500円を表示しない
      if (this.pricesMax[0] === 500 && serviceType !== 'phone') {
        this.pricesMax.splice(0, 1)
      }
    },
    priceText(price) {
      return this.$util.numberWithDelimiter(Number(price)) + '円'
    },
    setAttributes(key, value) {
      this.$emit('change-attributes', {
        key,
        value,
        emitChangeEvent: false
      })
    },
    /**
     * カテゴリ固有の検索条件変更
     * attributesへの変更がすべて完了してからchangeイベントを発火させる
     */
    setOptionAttributes(event) {
      const { key, value } = event
      this.setAttributes(key, value)
    }
  },
  watch: {
    // NOTE: 現在、SP時にnewValueとoldValueの値が同じになってしまう挙動が確認されている。
    // 対策としては監視している値をdeepCopyされたものにするなど要検討
    // 参考: https://coconala.slack.com/archives/C021EPCTHL6/p1631799449020600
    'condition.value': {
      deep: true,
      handler(newValue, oldValue) {
        this.innerCondition = this.$util.clone(this.condition)
        if (newValue.categoryId !== oldValue.categoryId) {
          this.setCategoryMaster()
          this.genPrices()
        } else if (newValue.serviceClass !== oldValue.serviceClass) {
          this.genPrices()
        }
      }
    },
    innerCondition: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.priceMin !== oldValue.priceMin) {
          this.genPrices()
        }
        if (newValue.priceMax !== oldValue.priceMax) {
          this.genPrices()
        }
      }
    },
    selectedPriceMin(newValue) {
      if (!newValue) {
        this.innerCondition.value.priceMin = ''
        this.genPrices()
      }
    },
    selectedPriceMax(newValue) {
      if (!newValue) {
        this.innerCondition.value.priceMax = ''
        this.genPrices()
      }
    },
    selectedUnitPriceMin(newValue) {
      if (!newValue) {
        this.innerCondition.value.priceMin = ''
        this.genPrices()
      }
    },
    selectedUnitPriceMax(newValue) {
      if (!newValue) {
        this.innerCondition.value.priceMax = ''
        this.genPrices()
      }
    }
  },
  computed: {
    ...mapState('master', ['pricesMaster', 'masterCategories', 'optionMastersList']),
    conditionOptions() {
      if (!this.innerCondition.value.conditionOptionsList) {
        return []
      }
      return this.innerCondition.value.conditionOptionsList
        .map(option => {
          const master = this.searchOptionMasters.find(
            e => e.keyCategoryId === option.keyCategoryId
          )
          // マスターの存在しない検索オプションは除外する
          if (!master) {
            return null
          }
          return {
            option,
            master
          }
        })
        .filter(x => !!x)
    },
    currentCategoryId() {
      if (this.$route.params.categoryId) {
        return Number(this.$route.params.categoryId)
      }
      if (this.$route.query.category_id) {
        return this.$util.castToNumberQueryString(this.$route.query.category_id)
      }
      return null
    }
  },
  created() {
    this.innerCondition = this.$util.clone(this.condition)
    // カテゴリ指定のあるURLで流入してきた場合はカテゴリをロックしておく
    this.isCategoryLocked = !!this.$route.params.categoryId || !!this.$route.query.category_id
    this.setCategoryMaster()
    this.genPrices()
  },
  mounted() {
    this.genPrices()
  }
})

export default searchConditionSelectPrice
